import VerificationStatusPill from './VerificationStatusPill';

export { NOT_APPLICABLE_STATUS } from './VerificationStatusPill';
export default VerificationStatusPill;
